import React from "react";
import { XIcon } from "lucide-react";
import { pains } from "../data/content";
export function PainSection() {
  return <section className="border-t border-line bg-panel px-4 py-14 sm:px-5 sm:py-20" data-id="element-92" data-mp="38wlusvaiuwis">
      <div className="mx-auto grid max-w-5xl items-center gap-8 lg:grid-cols-2 lg:gap-12" data-id="element-93" data-mp="2ux3zdx2q0l0g">
        <img src="https://cdn.magicpatterns.com/patterns/generated-images/7923d0c0-22d8-43a3-a16b-eaabf34d5feb.jpg" alt="Un professeur de guitare montre une fiche de cours à son élève" className="w-full rounded-2xl" data-id="element-94" data-mp="2yyzcrzxxeoul" />
        <div data-id="element-95" data-mp="2q0vpoz7alk0o">
          <h2 className="font-display text-3xl uppercase leading-tight text-cream sm:text-5xl" data-id="element-96" data-mp="2ba6e3vpx62wa">
            Enseigner, vous adorez. <span className="text-gold" data-id="element-97" data-mp="2g8pw5l1e6ujd">Planifier, beaucoup moins.</span>
          </h2>
          <ul className="mt-6 space-y-4 sm:mt-8" data-id="element-98" data-mp="229qcyswnf7ul">
            {pains.map(p => <li key={p} className="flex gap-3 text-base text-mute sm:text-lg" data-id="element-99" data-mp="278l2set19wo7">
                <XIcon className="mt-1 h-5 w-5 shrink-0 text-ribbon" aria-hidden data-id="element-100" data-mp="27anpaouz97o6" />
                {p}
              </li>)}
          </ul>
          <p className="mt-6 font-serif text-lg italic text-cream sm:mt-8 sm:text-xl" data-id="element-101" data-mp="3nm73skv513b4">
            Et si chaque cours était déjà prêt, imprimé, et pensé pour faire progresser vos élèves ?
          </p>
        </div>
      </div>
    </section>;
}